export default "__VITE_ASSET__CULQon$4__"